import TechRadar from "../../../../assets/icons/techradar-logo-w.svg";
import TechCrunch from "../../../../assets/icons/techcrunch-logo-w.svg";
import Fox from "../../../../assets/icons/fox-logo-w.svg";
import Gizmodo from "../../../../assets/icons/gizmodo-logo-w.svg";
import Wired from "../../../../assets/icons/logo-Wired-w.svg";
import s from "../QuizEnd.module.scss";

const fallBackIcons = [
  { image: TechRadar },
  { image: TechCrunch },
  { image: Fox },
  { image: Gizmodo },
  { image: Wired },
];
const base = window.post_template.checkout_v4_quiz;
const quizSponsoredLogos = base?.quiz_logos_repeater || fallBackIcons;

const QuizEndLogos = () => {
  return (
    <div className={s["logos"]}>
      <div className={s["logos__container"]}>
        {quizSponsoredLogos.map((item, index) => (
          <img src={item.image} alt="Company Logo" className={s["logos__container--image"]} key={index} />
        ))}
      </div>
    </div>
  );
};

export default QuizEndLogos;
